import { useEffect } from 'react';
import { AndroidOutlined, AppleOutlined, MobileOutlined } from '@ant-design/icons';
import './download.scss';

function Download() {
  useEffect(() => {
    if (/(micromessenger)/i.test(navigator.userAgent)) {
      const ele = document.getElementById('tips-download');
      if (ele?.style) {
        ele.style.display = 'block';
      }
    }
  }, []);

  const features = [
    {
      title: '【潮玩手办，正版直供】',
      text: '从热门IP到稀缺限量，陪你解锁收藏的无限可能。',
    },
    {
      title: '【电子产品、家电、箱包应有尽有】',
      text: '不只是买"想要的"，更能发现"意想不到的"。',
    },
    {
      title: '【全网玩法，一网打尽】',
      text: '一发入魂的无限模式、热血比拼的擂台玩法、惊险刺激的爬塔挑战、期待满满的抽卡机、实惠爆棚的福利房，带来前所未有的潮流娱乐体验。',
    },
    {
      title: '【会员等级，福利加持】',
      text: '等级越高，特权越多，专属福利享不停。',
    },
    {
      title: '【用户成长体系，回馈每一份热爱】',
      text: '让每一次点击与下单，都能积累属于你的荣耀。',
    },
  ];

  return (
    <div className="download-page">
      <div className="download-content">
        <div className="download-logo">
          <img
            src={`${process.env.PUBLIC_URL}/image/logo.png`}
            alt="logo"
          />
        </div>

        <div className="download-title">呱呱模玩</div>
        <div className="download-subtitle">正品潮玩聚集地，惊喜盲盒随时开！</div>

        <div className="download-buttons">
          <button
            className="download-btn btn-android"
            onClick={() => {
              window.location.href = 'https://sj.qq.com/appdetail/com.guaguamowan.www?scenevia=XQYFX&from_wxz=1';
            }}
          >
            <AndroidOutlined />
            Android 下载
          </button>

          <button
            className="download-btn btn-ios"
            onClick={() => {
              window.location.href = 'https://apps.apple.com/cn/app/%E5%91%B1%E5%91%B1%E6%A8%A1%E7%8E%A9/id6781125513';
            }}
          >
            <AppleOutlined />
            iOS 下载
          </button>

          <button
            className="download-btn btn-harmony"
            onClick={() => {
              window.location.href = 'https://appgallery.huawei.com/app/detail?id=com.guaguamowan.www&channelId=SHARE&source=appshare';
            }}
          >
            <MobileOutlined />
            鸿蒙 下载
          </button>
        </div>

        <div className="download-features">
          <div className="feature-card feature-highlight">
            <div className="feature-title">呱呱模玩是一个领先的潮流购物社区</div>
            <div className="feature-text">我们为你打造正品保障、极速物流、全品类覆盖的一站式购物新体验。极速物流直邮到家！在这里，潮流不止步，惊喜无极限！</div>
          </div>

          {features.slice(0, 2).map((item, index) => (
            <div key={index} className="feature-card">
              <div className="feature-title">{item.title}</div>
              <div className="feature-text">{item.text}</div>
            </div>
          ))}

          <div className="feature-card feature-wide">
            <div className="feature-title">{features[2].title}</div>
            <div className="feature-text">{features[2].text}</div>
          </div>

          <div className="feature-card">
            <div className="feature-title">{features[3].title}</div>
            <div className="feature-text">{features[3].text}</div>
          </div>

          <div className="feature-card">
            <div className="feature-title">{features[4].title}</div>
            <div className="feature-text">{features[4].text}</div>
          </div>

          <div className="feature-summary">
            <p>
              买得到，玩得爽，收获快！在呱呱模玩，你不仅是
              <span className="highlight-text">购物者</span>，更是
              <span className="highlight-text">探索者</span>；
              你收获的不只是商品，更是潮流的惊喜与快乐！
            </p>
          </div>

          <div className="download-footer-tag">呱呱模玩 —— 正品潮玩聚集地，惊喜盲盒随时开！</div>
        </div>
      </div>

      <div id="tips-download">
        <img
          className="tips-download-img"
          src={`${process.env.PUBLIC_URL}/image/wechat-tips.png`}
          alt=""
        />
      </div>
    </div>
  );
}

export default Download;
